type GuideStepRowProps = {
  index: number;
  title: string;
  body: string;
};

export default function GuideStepRow({ index, title, body }: GuideStepRowProps) {
  return (
    <div className="flex gap-5">
      <div className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#229ED9] text-[13px] font-extrabold text-white">
        {index}
      </div>
      <div className="text-[0.95rem] leading-[1.7] text-[var(--dash-text-muted)]">
        <span className="mb-0.5 block text-[1.05rem] font-bold text-[var(--dash-text-strong)]">
          {title}
        </span>
        {body}
      </div>
    </div>
  );
}
